const audioContext = new AudioContext();

export default audioContext;